export default __webpack_public_path__ + "static/media/1235.7603de53.png";